import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-dashboard-square-01-Bulk',
  standalone: true,
  templateUrl: '../../assets/dashboard-square-01/Bulk.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamDashboardSquare01BulkIcon {}
